import { isNaN, toPercent } from 'volta/utils/math-utils';

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type IntlService from 'ember-intl/services/intl';
import type { IDemandForecastPeriod } from 'volta/models/types/forecasts';

type QtyFormat = 'percent' | 'number';

export type TSelectedRow = {
  row: IDemandForecastPeriod;
  forecastType: string;
  value: number;
};
export default class SkuDetailsForecastsQtyCell extends Component<{}> {
  @service intl!: IntlService;

  @tracked selectedRow?: TSelectedRow;
  @tracked qtyFormat: QtyFormat = 'number';
  @tracked editedDemandQtyValue: Record<QtyFormat, number | undefined> = {
    number: undefined,
    percent: undefined
  };

  get saveIsDisabled(): boolean {
    const value = this.editedDemandQtyValue[this.qtyFormat];
    return value === undefined || value === this.formattedDemandQty;
  }

  get formattedDemandQty() {
    if (this.selectedRow?.value) {
      const formatted = +this.intl.formatNumber(this.selectedRow.value, {
        useGrouping: false
      });
      return isNaN(formatted) ? +this.selectedRow.value.toFixed(3) : formatted;
    }
    return undefined;
    //return this.editedDemandQtyValue[this.qtyFormat];
  }

  @action
  toggleRow(row?: TSelectedRow) {
    if (!row) {
      this.selectedRow = undefined;
    } else {
      this.selectedRow = row;
      this.qtyFormat = 'number';
      this.editedDemandQtyValue = {
        number: this.formattedDemandQty,
        percent: undefined
      };
    }
  }

  @action
  selectFormat(style: 'number' | 'percent') {
    if (this.qtyFormat !== style) {
      this.qtyFormat = style;
      if (style === 'percent' && !this.editedDemandQtyValue.percent) {
        this.editValue(
          isPresent(this.editedDemandQtyValue.number) && this.selectedRow
            ? toPercent(this.editedDemandQtyValue.number!, this.selectedRow.value)
            : 1
        );
      }
    }
  }

  @action
  editValue(value: number) {
    this.editedDemandQtyValue = {
      ...this.editedDemandQtyValue,
      [this.qtyFormat]: value
    };
  }
}
